<template>
    <div>
        <el-table :data="contractLogInfo.contractLogItemList" border style="width: 100%">
            <el-table-column prop="tblName" label="业务主体" width="180" align="left"></el-table-column>
            <el-table-column prop="subName" label="变动主体" width="180" align="left" show-overflow-tooltip></el-table-column>
            <el-table-column prop="fldName" label="数据项" align="left"></el-table-column>
            <el-table-column prop="oldValue" label="上一版" align="left">
                <template slot-scope="rows">
                    <span v-if="rows.row.oldValue == 'false'">否</span>
                    <span v-else-if="rows.row.oldValue == 'true'">是</span>
                    <span v-else>{{rows.row.oldValue}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="newValue" label="当前版" align="left">
                <template slot-scope="rows">
                    <span v-if="rows.row.newValue == 'false'">否</span>
                    <span v-else-if="rows.row.newValue == 'true'">是</span>
                    <span v-else>{{rows.row.newValue}}</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'

    import contractApi from '../../api/contract'

    export default {
        name: 'swb-contract-log-info',
        desc: '合同日志列表',
        props: ['contractLogId'],
        data: function () {
            return {
                contractLogInfo: [],
            }
        },
        created: function () {
            this.getContractLogInfo();
        },
        methods: {
            getContractLogInfo: function () {
                let self = this;
                let postData = {};
                postData.id = this.contractLogId;
                contractApi.getContractLog(postData, function (result) {
                    if (result.type === 'info') {
                        //
                        self.contractLogInfo = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/contract/ContractLogInfo.vue